import { OfferProductDto } from "@intelligems/ig-types";
import { createSlice } from "@reduxjs/toolkit";
import { createSelector, type PayloadAction } from "@reduxjs/toolkit";

import { IOfferProductsState } from "./types";

const initialState: IOfferProductsState = {
  isSuccess: false,
  offerProducts: [],
  storedOfferProducts: [],
};

const offerProductsSlice = createSlice({
  name: "offerProducts",
  initialState,
  reducers: {
    resetOfferProducts: (draft) => {
      draft.isSuccess = false;
      draft.offerProducts = [];
      draft.storedOfferProducts = [];
    },
    resetOfferProductsToStored: (draft) => {
      //@TODO this is not what the function name suggests
      draft.offerProducts = [];
    },
    initOfferProducts: (
      draft,
      action: PayloadAction<{ offerProducts: OfferProductDto[] }>
    ) => {
      draft.storedOfferProducts = action.payload.offerProducts;
      draft.offerProducts = action.payload.offerProducts;
      draft.isSuccess = true;
    },
    setVariationOfferProducts: (
      draft,
      action: PayloadAction<{
        variationId: string;
        products: OfferProductDto[];
      }>
    ) => {
      if (!draft.offerProducts) return;

      const filteredProducts = draft.offerProducts.filter(
        (product) => product.variationId !== action.payload.variationId
      );
      draft.offerProducts = [...filteredProducts, ...action.payload.products];
    },
    setSelectedOfferVariationProducts: (
      draft,
      action: PayloadAction<{
        variationId: string;
        offerId: string;
        offerProducts: OfferProductDto[];
      }>
    ) => {
      const updatedDraft = draft.offerProducts.filter(
        (prod) => prod.variationId !== action.payload.variationId
      );
      const dupOfferProducts: OfferProductDto[] =
        action.payload.offerProducts.map((product) => {
          return {
            ...product,
            offerId: action.payload.offerId,
            variationId: action.payload.variationId,
          };
        });

      draft.offerProducts = [...updatedDraft, ...dupOfferProducts];
    },
    resetVariationOfferProducts: (
      draft,
      action: PayloadAction<{
        variationId: string;
      }>
    ) => {
      if (!draft.offerProducts) return;

      draft.offerProducts = draft.offerProducts.filter(
        (product) => product.variationId !== action.payload.variationId
      );
    },
    removeVariationOfferProduct: (
      draft,
      action: PayloadAction<{
        variationId: string;
        productId: string;
      }>
    ) => {
      if (!draft.offerProducts) return;
      const { variationId, productId } = action.payload;

      draft.offerProducts = draft.offerProducts.filter(
        (p) => p.variationId !== variationId || p.id !== productId
      );
    },
  },
  selectors: {
    getOfferProducts: (state) => state.offerProducts,
  },
});

export const {
  resetOfferProducts,
  initOfferProducts,
  removeVariationOfferProduct,
  setVariationOfferProducts,
  setSelectedOfferVariationProducts,
  resetOfferProductsToStored,
  resetVariationOfferProducts,
} = offerProductsSlice.actions;

export const offerProductsReducer = offerProductsSlice.reducer;
export const { getOfferProducts } = offerProductsSlice.selectors;
